import React from 'react';

export const EqFocalDepthModal = {
  title: 'Focal Depth (km)',
  body: (
    <div>
      <p>The depth of the earthquake is given in kilometers.</p>
    </div>
  ),
};
